import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import "../../statusIcon.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { formatStatus } from "../../redux/humanResources/humanResourcesStatusActions";
import "../ListDetail.css";
import { downloadInterview, changeEvaluator, generateAndLoadForm, getFiltersInstance } from "../../redux/humanResources/humanResourcesActions";
import { Button, CardActions, Icon, Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';

const styles = {
    cardActions: {
        padding: 1,
        width: "100%",
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        marginTop: "10px",
        paddingLeft: "15px",
    },
    smallButton: {
        margin: "0 20px 0 0",
        padding: 0,
    },
};

class HRFormListDetail extends Component {
    displayForm() {
        this.props.generateAndLoadForm(this.props.interview, this.props.activeUser, () => {
            this.props.history.push("/humanResources/form");
            this.props.globalContainer.current.scrollTop = 0
        });
    }

    download() {
        this.props.downloadInterview(this.props.interview, this.props.activeUser)
    }

    changeEvaluator(event) {
        event.stopPropagation();
        this.props.changeEvaluator(this.props.interview, this.props.activeUser, this.props.formsFilters[getFiltersInstance(false, true, false)])
    }

    render() {
        const { classes } = this.props;

        return (
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 div-card">
                <div ref={(divRef) => (this.divRef = divRef)}>
                    <Card className="col-lg-12 col-md-12 col-sm-12 col-12 card list-detail-card card-margin-top without-side-padding">
                        <CardContent
                            className="without-padding card-content-left-align"
                            onClick={this.displayForm.bind(this)}
                        >
                            <div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
                                        <div className="without-side-padding blue-text" style={{display: "flex", justifyContent: "center"}}>
                                            <span className="bold">{this.props.interview.user_to_review_id ? this.props.interview.user_to_review_id.name : ""}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className={this.props.interview.has_response || 
                                        (this.props.interview.state !== "done" && this.props.interview.manager_n2_id && this.props.interview.manager_n2_id.id === this.props.activeUser.emp_id 
                                        && this.props.activeUser.id !== this.props.interview.user.id && this.props.interview.phase.action !== "self") ? "col-lg-10 col-md-10 col-sm-10 col-10 row" : "col-lg-12 col-md-12 col-sm-12 col-12 row"} style={{paddingRight: "10px !important", paddingLeft: "0px !important"}}>
                                        <div className="col-lg-7 col-md-7 col-sm-7 col-7 without-side-padding row card-div-border-right">
                                            <div className="span-center bold">
                                                <span>
                                                    {this.props.interview.plan.name}
                                                </span>                                                    
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-md-5 col-sm-5 col-5 without-side-padding row">
                                            <div className="span-center">
                                                <span>
                                                    {this.props.interview.hr_period.name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
                                        <div className="col-lg-7 col-md-7 col-sm-7 col-7 without-side-padding row card-div-border-right">
                                            <div className="span-center">
                                                <span>
                                                    {this.props.interview.phase.name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-md-5 col-sm-5 col-5 without-side-padding row">
                                            <div className="span-center">
                                                <span>
                                                    {formatStatus(this.props.interview.state, this.props.interview.has_response)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.interview.has_response || 
                                    (this.props.interview.state !== "done" && this.props.interview.manager_n2_id && this.props.interview.manager_n2_id.id === this.props.activeUser.emp_id 
                                    && this.props.activeUser.id !== this.props.interview.user.id && this.props.interview.phase.action !== "self") ? (<div className="col-lg-2 col-md-2 col-sm-2 col-2 row without-side-padding" style={{marginLeft: "5px !important"}}>
                                        {this.props.interview.state !== "done" && this.props.interview.manager_n2_id && this.props.interview.manager_n2_id.id === this.props.activeUser.emp_id ? 
                                            (<CardActions className={classes.cardActions} disableSpacing sx={{marginTop: "0px"}}>                            
                                                <Tooltip id="tooltip-icon" title="Mener l'entretien">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className={classes.smallButton}
                                                        onClick={this.changeEvaluator.bind(this)}
                                                        sx={{minWidth: 0, width: "100%"}}
                                                    >
                                                        <TransferWithinAStationIcon/>
                                                    </Button>
                                                </Tooltip>                            
                                            </CardActions>) 
                                        : null}
                                        {this.props.interview.has_response ? (
                                            <CardActions className={classes.cardActions} disableSpacing sx={{marginTop: "0px"}}>                            
                                                <Tooltip id="tooltip-icon" title="Télécharger">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className={classes.smallButton}
                                                        onClick={this.download.bind(this)}
                                                        sx={{minWidth: 0, width: "100%"}}
                                                    >
                                                        <Icon>download</Icon>
                                                    </Button>
                                                </Tooltip>                            
                                            </CardActions>
                                        ) : null}
                                    </div>) : null}                                    
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        formsFilters: state.forms.formsFilters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        generateAndLoadForm: (interview, user, onSuccess) => dispatch(generateAndLoadForm(interview, user, onSuccess)),
        downloadInterview: (interview, user) => dispatch(downloadInterview(interview, user)),
        changeEvaluator: (inteview, user, formsFilters) => dispatch(changeEvaluator(inteview, user, formsFilters)),
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(HRFormListDetail);
